module.exports = __webpack_public_path__ + "static/media/close_w.73b1a72f.svg";